import { render, staticRenderFns } from "./AmountInputConfig.vue?vue&type=template&id=0a74aaa0&scoped=true"
import script from "./AmountInputConfig.vue?vue&type=script&lang=js"
export * from "./AmountInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74aaa0",
  null
  
)

export default component.exports